
export const menuManagement = [
  {
    title: 'Transport - widok tygodnia',
    path: '/carriageList',
    cName: 'dropdown-link',
    permissions: ['manageCarriage'],
  },
  {
    title: 'Transport - sprzedane transporty',
    path: '/soldCarriageList',
    cName: 'dropdown-link',
    permissions: ['manageCarriage'],
  },
  {
    title: 'Palety - bilans',
    path: '/carriagePaletteClientsList',
    cName: 'dropdown-link',
    permissions: ['managePaletts'],
  },
  {
    title: 'Faktury',
    path: '/invoiceList',
    cName: 'dropdown-link',
    permissions: ['manageInvoice'],
  },
  {
    title: 'Ładunki',
    path: '/carriageNotes',
    cName: 'dropdown-link',
    permissions: ['manageCarriage'],
  },
];
export const menuAdministration = [
  {
    title: 'Baza pojazdów',
    path: '/carsList',
    cName: 'dropdown-link',
    permissions: ['manageCarriage', 'managePaletts'],
  },
  {
    title: 'Baza klientów',
    path: '/clientsList',
    cName: 'dropdown-link',
    permissions: ['manageCarriage', 'managePaletts'],
  },
  {
    title: 'Baza kierowców',
    path: '/driversList',
    cName: 'dropdown-link',
    permissions: ['manageCarriage', 'managePaletts'],
  },
  {
    title: 'Statystyki',
    path: '/statistics',
    cName: 'dropdown-link',
    permissions: ['administrator'],
  },
  {
    title: 'Dziennik zdarzeń',
    path: '/auditLog',
    cName: 'dropdown-link',
    permissions: ['administrator'],
  },
  {
    title: 'Notatki',
    path: '/notes',
    cName: 'dropdown-link',
    permissions: ['manageNotes'],
  },
];
export const menuUser = [
  {
    title: 'Zaktualizuj swoje dane',
    path: '/editUser',
    cName: 'dropdown-link',
    permissions: ['manageUsers','manageCarriage', 'managePaletts'],
  },
  {
    title: 'Zaktualizuj dane użytkowników',
    path: '/userList',
    cName: 'dropdown-link',
    permissions: ['manageUsers'],
  },
  {
    title: 'Dodaj użytkownika',
    path: '/register',
    cName: 'dropdown-link',
    permissions: ['manageUsers'],
  },
  // {
  //   title: 'Zmiana hasła',
  //   path: '/userList',
  //   cName: 'dropdown-link',
  //   permissions: ['manageUsers','manageCarriage', 'managePaletts'],
  // },
];